// AUTO-GENERATED CODE, DO NOT EDIT!
/* eslint-disable */

import * as Types from "../../types";

import gql from "graphql-tag";
import * as Urql from "urql";
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type VenueSustainableInitiativesGetSustainabilityInitiativesForVenueQueryVariables =
  Types.Exact<{
    input: Types.GetSustainabilityInitiativesForVenueInput;
  }>;

export type VenueSustainableInitiativesGetSustainabilityInitiativesForVenueQuery =
  {
    __typename?: "Query";
    getSustainabilityInitiativesForVenue: Array<{
      __typename?: "SustainabilityInitiative";
      id: number;
      label: string;
      category: Types.SustainabilityInitiativeCategory;
    }>;
  };

export type VenueSustainableInitiativesGetSustainabilityInitiativesQueryVariables =
  Types.Exact<{ [key: string]: never }>;

export type VenueSustainableInitiativesGetSustainabilityInitiativesQuery = {
  __typename?: "Query";
  sustainabilityInitiatives?: Array<{
    __typename?: "SustainabilityInitiative";
    id: number;
    label: string;
    category: Types.SustainabilityInitiativeCategory;
  } | null> | null;
};

export type VenueSustainableInitiativesSustainabilityInitiativeFragment = {
  __typename?: "SustainabilityInitiative";
  id: number;
  label: string;
  category: Types.SustainabilityInitiativeCategory;
};

export type VenueSustainableInitiativesVenueFragment = {
  __typename?: "SelfServeVenue";
  ID?: number | null;
};

export const VenueSustainableInitiativesSustainabilityInitiativeFragmentDoc = gql`
  fragment VenueSustainableInitiativesSustainabilityInitiative on SustainabilityInitiative {
    id
    label
    category
  }
`;
export const VenueSustainableInitiativesVenueFragmentDoc = gql`
  fragment VenueSustainableInitiativesVenue on SelfServeVenue {
    ID
  }
`;
export const VenueSustainableInitiativesGetSustainabilityInitiativesForVenueDocument = gql`
  query VenueSustainableInitiativesGetSustainabilityInitiativesForVenue(
    $input: GetSustainabilityInitiativesForVenueInput!
  ) {
    getSustainabilityInitiativesForVenue(input: $input) {
      ...VenueSustainableInitiativesSustainabilityInitiative
    }
  }
  ${VenueSustainableInitiativesSustainabilityInitiativeFragmentDoc}
`;

export function useVenueSustainableInitiativesGetSustainabilityInitiativesForVenueQuery(
  options: Omit<
    Urql.UseQueryArgs<VenueSustainableInitiativesGetSustainabilityInitiativesForVenueQueryVariables>,
    "query"
  >
) {
  return Urql.useQuery<
    VenueSustainableInitiativesGetSustainabilityInitiativesForVenueQuery,
    VenueSustainableInitiativesGetSustainabilityInitiativesForVenueQueryVariables
  >({
    query:
      VenueSustainableInitiativesGetSustainabilityInitiativesForVenueDocument,
    ...options,
  });
}
export const VenueSustainableInitiativesGetSustainabilityInitiativesDocument = gql`
  query VenueSustainableInitiativesGetSustainabilityInitiatives {
    sustainabilityInitiatives {
      ...VenueSustainableInitiativesSustainabilityInitiative
    }
  }
  ${VenueSustainableInitiativesSustainabilityInitiativeFragmentDoc}
`;

export function useVenueSustainableInitiativesGetSustainabilityInitiativesQuery(
  options?: Omit<
    Urql.UseQueryArgs<VenueSustainableInitiativesGetSustainabilityInitiativesQueryVariables>,
    "query"
  >
) {
  return Urql.useQuery<
    VenueSustainableInitiativesGetSustainabilityInitiativesQuery,
    VenueSustainableInitiativesGetSustainabilityInitiativesQueryVariables
  >({
    query: VenueSustainableInitiativesGetSustainabilityInitiativesDocument,
    ...options,
  });
}
